import React from 'react';
import { useHistory } from 'react-router-dom';
import parse from 'html-react-parser';

import { Button as ReactButton } from '@a-ui/react';
import Box from '../../../components/Box';
import { DetailLayout } from '../../../components/DetailLayout';
import Typography from '../../../components/Typography';
// import useConfig from '../../../hooks/config.hooks';
import { translate, translateHTML } from '../../../i18n';
import { useAuthentication } from '../../../state/Authentication';

const EIDAdd: React.FC = () => {
  const {
    state: { eID },
  } = useAuthentication();
  const history = useHistory();
  // const { EID_INFO_URL } = useConfig();

  React.useEffect(() => {
    if (eID?.rrnr) history.replace('/gegevens/aanmeldsleutels/rijksregisternummer');
  }, [eID]);

  return (
    <DetailLayout
      backAction="/gegevens"
      backLabel="accessKeys.overview.title"
      title="accessKeys.eid.title"
      description="accessKeys.eid.add.intro"
    >
      <Box>
        <Typography variant="h2" as="h6" classNames="u-margin-bottom-xs">
          {translate('accessKeys.eid.add.subtitle')}
        </Typography>

        <Typography classNames="u-margin-bottom-xs">
          {parse(translateHTML('accessKeys.eid.add.body') as string)}
        </Typography>

        <div className="u-margin-top">
          <ReactButton
            fullWidth
            onClick={() => {
              window.location.href = `/auth/login?minimal_assurance_level=substantial&fromUrl=${window.location.origin}/gegevens?eid_added=1`;
            }}
          >
            {translate('common.button.next')}
          </ReactButton>
        </div>
      </Box>
    </DetailLayout>
  );
};

export default EIDAdd;
